import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { IdentificationDocumentType } from '@/gql/graphql'

// Label for each document type. TS will flag missing cases.
const labels: Record<IdentificationDocumentType, () => string> = {
  [IdentificationDocumentType.Passport]: () => $t('Passport'),
  [IdentificationDocumentType.NationalIdCard]: () => $t('National ID card'),
  [IdentificationDocumentType.ResidencePermit]: () => $t('Residence permit'),
}

export const identificationDocumentTypeLabel = (type: IdentificationDocumentType): string =>
  labels[type]()

export interface IdentificationDocumentTypeOption {
  label: string
  value: IdentificationDocumentType
}

// `[{ label, value }]` list of every document type.
export const identificationDocumentTypeOptions = (): IdentificationDocumentTypeOption[] =>
  Object.values(IdentificationDocumentType).map((value) => ({
    label: identificationDocumentTypeLabel(value),
    value,
  }))
